import InvitationsScreen from './InvitationsScreen';

export const HypothesisInvitationsScreen = (props: any) => (
  <InvitationsScreen {...props} sessionType="hypothesis_sprint" />
);

export default HypothesisInvitationsScreen;
